module.exports = __webpack_public_path__ + "img/beta-tile.44f6663.jpg";